import { render, staticRenderFns } from "./MemberArrangeItem.vue?vue&type=template&id=380fa2c4&scoped=true"
import script from "./MemberArrangeItem.vue?vue&type=script&lang=js"
export * from "./MemberArrangeItem.vue?vue&type=script&lang=js"
import style0 from "./MemberArrangeItem.vue?vue&type=style&index=0&id=380fa2c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380fa2c4",
  null
  
)

export default component.exports